import type { SxProps, Theme } from '@mui/material'

export const styles = {
  backdrop: {
    color: '#fff',
    zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
    flexDirection: 'column',
    gap: 2,
  } as SxProps<Theme>,
}
